<template>
  <div>
    <v-btn
      rounded
      small
      depressed
      color="primary"
      @click="openDialog"
    >
      Crear restaurante
    </v-btn>
    <v-dialog
      @keydown.esc="isOpen=false"
      v-model="isOpen"
      persistent
      max-width="400px"
    >
      <v-card>
        <v-card-title>
          Nuevo restaurante
        </v-card-title>
        <v-form v-model="isValid" ref="newRestaurant">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex md12>
                <v-text-field
                  v-model="form.name"
                  label="Nombre"
                  :rules="rules.name"
                />
              </v-flex>
              <v-flex md12>
                <v-autocomplete
                  v-model="form.country"
                  label="País"
                  placeholder="MX"
                  :items="countrycodes"
                  :filter="searchCode"
                  item-text="name"
                  item-value="code"
                  dense
                  rounded
                  hide-details
                  outlined
                  :rules="rules.country"/>
              </v-flex>
              <v-flex md12>
                <v-checkbox color="primary" v-model="form.acceptedTOS">
                  <template v-slot:label>
                    <div>
                      <span>
                        Aceptar
                      </span>
                      <a @click.stop class="primary--text" href="https://docs.google.com/document/d/1Te9qJSArXl5YExlTpDzEl_sipAAZXC1DSyc5fJ8uP-I/edit" target="_blank">términos y condiciones</a>
                    </div>
                  </template>
                </v-checkbox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="mr-4"
            rounded
            outlined
            small
            depressed
            @click="closeDialog">
            {{ $t('ctas.close') }}
          </v-btn>
          <v-btn
            color="primary"
            rounded
            small
            depressed
            :disabled="!isValid || !form.acceptedTOS"
            @click="createRestaurant">
            {{ $t('ctas.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import countrycodes from '@/lib/countrycodes'
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      overlay: false,
      isValid: false,
      isOpen: false,
      countrycodes,
      form: {
        name: null,
        country: 'MX',
        acceptedTOS: false
      },
      rules: {
        name: [v => !!v || this.$t('validations.name')],
        country: [v => !!v || 'Country is required']
      }
    }
  },
  methods: {
    ...mapActions(['login/loadRestaurants']),
    searchCode (item, queryText, itemText) {
      const name = item.name.toLowerCase()
      const searchText = queryText.toLowerCase()
      return name.indexOf(searchText) >= 0
    },
    openDialog () {
      const vm = this
      setTimeout(() => { vm.isOpen = true })
    },
    closeDialog () {
      this.resetForm()
      this.isOpen = false
    },
    resetForm () {
      this.form = {
        name: null,
        country: 'MX'
      }
      this.$refs.newRestaurant.resetValidation()
    },
    async createRestaurant () {
      if (this.isValid) {
        this.overlay = true
        try {
          await this.$api.post('/v1/restaurants', this.form)
          await this['login/loadRestaurants']()
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
        this.resetForm()
        this.isOpen = false
      }
    }
  }
}
</script>
